export const surface = {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    bgcolor: '#fff',
};

export const headerCell = {
    fontWeight: 600,
    color: '#6b7280',
    backgroundColor: '#f9fafb',
    fontSize: '0.75rem',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    borderBottom: '1px solid #e5e7eb',
    py: 1.25,
};

export const formatDate = (value) => {
    if (!value) return '—';
    return new Date(value).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
};

export const money = (amount, currency = 'USD') => {
    if (amount === null || amount === undefined) return '—';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
        }).format(amount);
    } catch {
        return `${amount} ${currency || ''}`.trim();
    }
};
